import React, { useEffect } from 'react'
import Navbar from '../Components/Header/Navbar'
import HeaderBar from '../Components/Header/HeaderBar'


import { Outlet } from 'react-router-dom'
import Footer from '../Components/Footer'
import Aos from 'aos';
import 'aos/dist/aos.css';

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';


function DefaultLayout() {

 
  useEffect(()=>{
    Aos.init({duration:500});
  
    },[])


   
    
  return (
  
<div>
<ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"
/>
{/* Same as */}
<ToastContainer />
  <div id="navbar" className='sticky top-0 z-50 bg-white shadow-md'>
<HeaderBar/>


<Navbar />
</div>
 

<div className='fade-in'>
<Outlet />
</div>






<Footer/>

</div>
  
 

    

   
 

  )
}

export default DefaultLayout
